import React from 'react';
import { I18n } from 'react-redux-i18n';
import get from 'lodash.get';

import { useAppSelector } from '../../../../hooks/redux/useApp';
import { AnnouncementBanner } from '../../../../components/common/announcementBanner';
import { isStripeConnected } from './isStripeConnected';

const i18nPath = 'organization.welcomeBanner';

/**
 * Welcome for a charity admin who has just accepted their invite and been sent
 * into the organisation settings wizard (`?onboarding=1`). Sits above the
 * wizard, so it stays put while the admin moves between tabs, and goes once
 * Stripe is connected: the Stripe return reloads the finance tab without the
 * onboarding flag, and the saved record then lists the Stripe platform.
 *
 * Not dismissible, since every wizard step stays optional and the banner is
 * the only prompt to finish them.
 */
export const OrganizationWelcomeBanner = () => {
  const isOnboarding = useAppSelector(
    (state) => get(state, 'templateBuilderEx.data.isOnboarding') === true
  );
  const stripeConnected = useAppSelector((state) =>
    isStripeConnected(state.organization.record.data?.data?.paymentPlatforms)
  );

  if (!isOnboarding || stripeConnected) {
    return null;
  }

  return (
    <AnnouncementBanner
      testId="organization-welcome-banner"
      title={I18n.t(`${i18nPath}.title`)}
      body={I18n.t(`${i18nPath}.body`)}
    />
  );
};

export default OrganizationWelcomeBanner;
